import React, { useContext, useEffect, useMemo, useState } from "react"
import { APIResponse } from "redux/apis/types"
import { SymbolDetailMoalNewsListContents } from "components/molecules/list/news"
import {
  NewsDetailContents,
  NewsModal,
} from "components/organisms/panel/newsList"
import APIs from "redux/apis"
import { get, isEmpty, size } from "lodash"
import { useSelector } from "react-redux"
import store from "redux/store"
import { refreshSymbol } from "redux/ducks/SymbolDetail"
import { SymbolDetailContext } from "components/pages/others/symbolDetail"
import { PAGE_NUM } from "config/const"
import { Pagination } from "components/molecules/pagination"
import uuid from "uuid"
import { pageLoadRegist } from "../../../../redux/ducks/PageLoad"

export const News = (symbolDetail: APIResponse.Res) => {
  const [result, setResult] = useState<Array<APIResponse.Res | null>>([])
  const [active, changeActive] = useState<number>(0)
  const [page, setPage] = useState<number>(0)
  const [totalCount, setTotalCount] = useState(0)
  const symbolDetailContext = useContext(SymbolDetailContext)
  const { setShowPerformanceNewsFlag } = symbolDetailContext
  const symbol = get(symbolDetail, "symbolDetail.Symbol")
  const loadingId = useMemo(() => uuid(), [])

  const isRefresh = useSelector(
    (state: { symbolDetail: { refresh: boolean } }) =>
      state.symbolDetail.refresh
  )
  const callApi = async () => {
    store.dispatch(pageLoadRegist(loadingId, true))
    const news: APIResponse.Res | {} = await APIs.News.News({
      WithDetail: true,
      DayCount: 90,
      Symbol: get(symbol, "Symbol"),
      _take: PAGE_NUM.PAGE_5,
      _skip: page * PAGE_NUM.PAGE_5,
    })
    if (!!get(news, "isAxiosError")) {
      setResult([])
      setTotalCount(0)
    } else {
      setResult(get(news, "ResultList", []))
      setTotalCount(get(news, "TotalCount", 0))
    }
    store.dispatch(pageLoadRegist(loadingId, false))
  }
  useEffect(() => {
    callApi()
  }, [symbol, page])

  useEffect(() => {
    if (isRefresh) {
      callApi()
      store.dispatch(refreshSymbol())
    }
  }, [isRefresh])

  const _changeActive = (id: number) => {
    changeActive(id)
  }

  useEffect(() => {
    _changeActive(0)
  }, [result])

  return (
    <div className="symbol-detail-news-contents">
      <div className="news-title-list" id="target">
        {isEmpty(result) ? (
          <div className="news-empty">
            <span>該当するニュースはありません</span>
          </div>
        ) : (
          <>
            <SymbolDetailMoalNewsListContents
              className="news-list"
              list={result}
              active={active}
              changeActive={_changeActive}
              onClick={() => setShowPerformanceNewsFlag(true)}
              onHide={() => {
                setShowPerformanceNewsFlag(false)
              }}
            />
            <Pagination
              total={totalCount}
              list={result}
              current={page}
              page={PAGE_NUM.PAGE_5}
              changePage={(num: number) => setPage(num)}
            />
          </>
        )}
      </div>
    </div>
  )
}

export const NewsOne = (symbolDetail: APIResponse.Res) => {
  const [result, setResult] = useState<Array<APIResponse.Res | null>>([])
  const symbol = get(symbolDetail, "symbolDetail.Symbol")
  const symbolDetailContext = useContext(SymbolDetailContext)
  const { setShowPerformanceNewsFlag } = symbolDetailContext
  const loadingId = useMemo(() => uuid(), [])
  const isRefresh = useSelector(
    (state: { symbolDetail: { refresh: boolean } }) =>
      state.symbolDetail.refresh
  )
  const callApi = async () => {
    store.dispatch(pageLoadRegist(loadingId, true))
    const news: APIResponse.Res | {} = await APIs.News.News({
      Symbol: symbol,
      DayCount: 90,
      _where: 'Category="MDD_FINANCIAL_RESULTS"',
      WithDetail: true,
      _take: 1,
    })
    if (!!get(news, "isAxiosError")) {
      setResult([])
    } else {
      setResult(get(news, "ResultList", []))
    }
    store.dispatch(pageLoadRegist(loadingId, false))
  }

  useEffect(() => {
    callApi()
  }, [symbol])

  useEffect(() => {
    if (isRefresh) {
      callApi()
    }
  }, [isRefresh])

  return (
    <div className="symbol-detail-news-contents">
      <div className="title-border">
        <span className="news-label">決算ニュース</span>
      </div>
      <div
        className="news-title-list"
        id="target"
        onClick={() => {
          !isEmpty(result) && setShowPerformanceNewsFlag(true)
        }}
      >
        {!isEmpty(result) ? (
          <SymbolDetailMoalNewsListContents
            className="news-list"
            list={result}
            active={1}
            changeActive={null}
            onHide={() => {
              setShowPerformanceNewsFlag(false)
            }}
          />
        ) : (
          <div>該当するニュースはありません</div>
        )}
      </div>
    </div>
  )
}
